/**
 *
 * Asynchronously loads the component for ClientList
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ClientList = lazyLoad(
  () => import('./index'),
  module => module.ClientList,
);
